import { DefaultFullPreview } from "@circle-react/components/Paywalls/Checkout/CheckoutPage/CheckoutForm/PricePreview/DefaultFullPreview";
import { Loader } from "@circle-react-uikit/Loader";
import { AddPaymentMethod } from "./AddPaymentMethod";
import { useChangePlanFormContext } from "./ChangePlanFormContext";
import { Coupon } from "./Coupon";
import { SelectedPlanDetails } from "./SelectedPlanDetails";
import { useCurrentAndSelectedPlans } from "./hooks/useCurrentAndSelectedPlans";

export const ConfirmationStep = () => {
  const {
    priceChangePreview,
    isInTrial,
    shouldAddPaymentMethod,
    previewMutation,
  } = useChangePlanFormContext();
  const { isLoadingSelectedPaywall, selectedPaywall } =
    useCurrentAndSelectedPlans();

  if (isLoadingSelectedPaywall) {
    return <Loader />;
  }

  return (
    <>
      <SelectedPlanDetails />
      {selectedPaywall?.coupons_enabled && <Coupon />}
      {previewMutation.isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="grid grid-cols-1 gap-y-6">
            <DefaultFullPreview.ProratedCreditPreview
              preview={priceChangePreview}
              className="pt-6"
            />
            <DefaultFullPreview.FirstPaymentPreview
              className="border-t pt-6"
              preview={priceChangePreview}
            />
            <DefaultFullPreview.FuturePaymentsPreview
              preview={priceChangePreview}
              className="pt-6"
            />
            <DefaultFullPreview.TotalDueTodayPreview
              preview={priceChangePreview}
            />
          </div>
          {isInTrial && shouldAddPaymentMethod && (
            <AddPaymentMethod className="" />
          )}
        </>
      )}
    </>
  );
};
